import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Box,
  Button,
  Divider,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  Select,
  Stack,
  TextField
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import ReactLoading from 'react-loading';
import { Header } from '../../components/Header';
import {
  Container,
  Content,
  Route,
  Title,
  OrientationTitle,
  OrientationImg,
  OrientationDescription,
  RadioWrapper
} from './styled';
import { useAuth } from '../../hooks/Auth';
import { useIntegration } from '../../hooks/Integration';
import { useManager } from '../../hooks/Manager';
import { usePickup } from '../../hooks/Pickup';

import { transport } from '../../assets/transport';

const GeneralShippingGuidelines = () => {
  const [transportTypeList, setTransportTypeList] = useState([]);
  const [materialTypeList, setMaterialTypeList] = useState([]);
  const [checkList, setCheckList] = useState([]);
  const [transportSelected, setTransportSelected] = useState('');
  const [hasTransportError, setHasTransportError] = useState(false);
  const [materialSelected, setMaterialSelected] = useState('');
  const [isLoadingModal, setIsLoadingModal] = useState(true);
  const [isLoadingMaterial, setIsLoadingMaterial] = useState(true);

  const { user, token, signOut, userAddressList } = useAuth();
  const { getBranchDetails } = useIntegration();
  const {
    getPickupManagerParameterization,
    getPickupManagerParameterizationTransportTypes,
    getPickupManagerBranchGeneralConfig,
    getPickupManagerBranchGeneralConfigTypes,
    getPickupManagerMaterialList,
    getPickupManagerCheckList
  } = useManager();
  const { branchParameterizationId, setCustomerAcceptGuidelines } = usePickup();

  const maxSM = useMediaQuery('(max-width:768px)');
  const maxMD = useMediaQuery('(max-width:900px)');

  const history = useHistory();

  const handleAccept = () => {
    let hasError = false;
    if (!transportSelected) {
      setHasTransportError(true);
      hasError = true;
    }

    if (hasError) {
      return;
    }

    setCustomerAcceptGuidelines(true);
    history.push('/acesso-rapido/tipo-de-solicitante');
  };

  const handleReject = () => {
    setCustomerAcceptGuidelines(false);
    history.push('/acesso-rapido/tipo-de-solicitante');
  };

  const onComponentDidMount = async () => {
    if (!branchParameterizationId) {
      history.push('/acesso-rapido/tipo-de-coleta');
      return;
    }

    setIsLoadingModal(true);
    setIsLoadingMaterial(true);
    setTransportTypeList([]);
    setMaterialTypeList([]);

    try {
      let zipPostalCode = '';

      if (userAddressList?.length > 0) {
        zipPostalCode = userAddressList[0]?.zipPostalCode;
      }

      const branchDetailsResponse = await getBranchDetails({
        params: { zip_code: zipPostalCode },
        token
      });

      const pickupManagerTransportTypesParams = {
        branchId: 1,
        pickupTypeId: 1,
        inputTypeId: 5
      };

      if (branchDetailsResponse?.length > 0) {
        pickupManagerTransportTypesParams.branchId =
          branchDetailsResponse[0].idFilial;
      }

      const pickupManagerParameterizationTransportTypesResponse =
        await getPickupManagerParameterizationTransportTypes({
          params: pickupManagerTransportTypesParams,
          token
        });

      if (pickupManagerParameterizationTransportTypesResponse.status === 200) {
        const { data: modalList } =
          pickupManagerParameterizationTransportTypesResponse?.data;

        if (modalList?.length > 0) {
          setTransportTypeList(modalList);
        }
      } else {
        const pickupManagerResponse = await getPickupManagerParameterization({
          branchId: 1,
          transportTypeId: 9,
          pickupTypeId: 1,
          inputTypeId: 5,
          token
        });

        if (pickupManagerResponse?.length > 0) {
          const generalConfigResponse =
            await getPickupManagerBranchGeneralConfig({
              branchParameterizationId:
                pickupManagerResponse[0]?.branchParameterizationId,
              token
            });

          if (generalConfigResponse?.length > 0) {
            const modalList = generalConfigResponse.filter(
              (config) => config.type === 'Modal' && config.enabled === true
            );

            if (modalList?.length > 0) {
              modalList?.map((value) => {
                if (value.description === 'Rodoviário') {
                  value.transportTypeId = 1;
                } else {
                  value.transportTypeId = 2;
                }

                return value;
              });

              setTransportTypeList(modalList);
            }
          }
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }

    setIsLoadingModal(false);
    setIsLoadingMaterial(false);
  };

  useEffect(onComponentDidMount, []);

  useEffect(async () => {
    if (transportSelected === '') return;

    setIsLoadingMaterial(true);
    setMaterialSelected('');
    setMaterialTypeList([]);
    setCheckList([]);

    try {
      const transportFounded = transportTypeList.find(
        (value) => value.transportTypeId === transportSelected
      );

      let transportTypeId = 9;

      if (transportFounded) {
        transportTypeId = transportFounded?.branchGeneralConfigurationId;
      }

      const params = {
        branchId: 1,
        transportTypeId,
        pickupTypeId: 1,
        inputTypeId: 5,
        token
      };

      let zipPostalCode = '';

      if (userAddressList?.length > 0) {
        zipPostalCode = userAddressList[0]?.zipPostalCode;
      }

      const branchDetailsResponse = await getBranchDetails({
        params: { zip_code: zipPostalCode },
        token
      });

      if (branchDetailsResponse?.length > 0) {
        params.branchId = branchDetailsResponse[0].idFilial;
      }

      const pickupManagerResponse = await getPickupManagerParameterization(
        params
      );

      let foundedBranchParameterizationId;

      if (pickupManagerResponse?.length > 0) {
        foundedBranchParameterizationId =
          pickupManagerResponse[0]?.branchParameterizationId;
      }

      if (!foundedBranchParameterizationId) {
        const defaultPickupManagerResponse =
          await getPickupManagerParameterization({
            branchId: 1,
            transportTypeId: 9,
            pickupTypeId: 1,
            inputTypeId: 5,
            token
          });

        if (defaultPickupManagerResponse?.length > 0) {
          foundedBranchParameterizationId =
            defaultPickupManagerResponse[0]?.branchParameterizationId;
        }
      }

      if (!foundedBranchParameterizationId) return;

      const materialListResponse = await getPickupManagerMaterialList({
        branchParameterizationId: foundedBranchParameterizationId,
        token
      });

      if (materialListResponse.status === 200) {
        const { data: materialList } = materialListResponse?.data;

        setMaterialTypeList(materialList);
      }

      const checkListResponse = await getPickupManagerCheckList({
        branchParameterizationId: foundedBranchParameterizationId,
        token
      });

      if (checkListResponse.status === 200) {
        const newCheckList = checkListResponse?.data?.data
          ?.filter((value) => value.enabled === true)
          ?.map((value) => {
            const { data: materialList } = materialListResponse?.data;

            value.materialName = '-';

            const materialFounded = materialList.find(
              (element) => element.branchMaterialId === value.branchMaterialId
            );

            if (materialFounded) {
              value.materialName = materialFounded.materialDescription;
            }

            return value;
          });

        setCheckList(newCheckList);
        setMaterialSelected('all');
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }

    setIsLoadingMaterial(false);
  }, [transportSelected]);

  return (
    <Container>
      {/* <Header /> */}
      <Content>
        <Box margin="0 40px" paddingBottom="40px">
          {/* <Route>
            {!maxSM && (
              <>
                Home {'>'} Acesso Rápido {'>'} Pedido de Coleta
              </>
            )}

            {!!user && (
              <Stack
                direction="row"
                spacing={2}
                style={{
                  alignItems: 'center',
                  marginLeft: maxSM && 'auto'
                }}
              >
                <p>{user.name}</p>
                <Button
                  type="button"
                  variant="contained"
                  color="secondary"
                  data-testid="signOutButton"
                  onClick={signOut}
                  size="small"
                >
                  Sair
                </Button>
              </Stack>
            )}
          </Route> */}

          <Title>Orientações Gerais de Transporte</Title>

          <Paper elevation={3} style={{ marginTop: 16, padding: 24 }}>
            <Stack direction={maxSM ? 'column' : 'row'} spacing={2}>
              {!isLoadingModal ? (
                <FormControl>
                  <InputLabel htmlFor="modal">Modal *</InputLabel>
                  <Select
                    id="modal"
                    label="Modal *"
                    style={{ minWidth: 176 }}
                    defaultValue=""
                    value={transportSelected}
                    error={hasTransportError}
                    onChange={(event) => {
                      setHasTransportError(false);
                      setTransportSelected(event.target.value);
                    }}
                  >
                    {transportTypeList.map(
                      ({ description, transportTypeId }) => (
                        <MenuItem key={transportTypeId} value={transportTypeId}>
                          {description}
                        </MenuItem>
                      )
                    )}
                  </Select>
                  {hasTransportError && (
                    <FormHelperText error={hasTransportError}>
                      Campo obrigatório
                    </FormHelperText>
                  )}
                </FormControl>
              ) : (
                <TextField
                  label="Modal *"
                  disabled
                  sx={{ width: 176 }}
                  InputProps={{
                    endAdornment: (
                      <ReactLoading
                        type="spin"
                        color="#808080"
                        width={16}
                        height={16}
                      />
                    )
                  }}
                />
              )}

              {!isLoadingModal && !isLoadingMaterial ? (
                <FormControl>
                  <InputLabel htmlFor="material">Tipo de Material</InputLabel>
                  <Select
                    id="material"
                    label="Tipo de Material"
                    style={{ minWidth: 176 }}
                    defaultValue=""
                    value={materialSelected}
                    onChange={(event) => {
                      setMaterialSelected(event.target.value);
                    }}
                  >
                    {checkList?.length > 0 && (
                      <MenuItem value="all">Todos</MenuItem>
                    )}
                    {checkList
                      ?.filter((value) => value.agroupBy === 0)
                      ?.map(({ materialName, branchChecklistId }) => (
                        <MenuItem
                          key={branchChecklistId}
                          value={branchChecklistId}
                        >
                          {materialName}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              ) : (
                <FormControl>
                  <TextField
                    label="Tipo de Material"
                    disabled
                    sx={{ width: 176 }}
                    InputProps={{
                      endAdornment: (
                        <ReactLoading
                          type="spin"
                          color="#808080"
                          width={16}
                          height={16}
                        />
                      )
                    }}
                  />
                </FormControl>
              )}
            </Stack>

            {materialTypeList?.length > 0 &&
              checkList?.filter((value) => {
                if (materialSelected && materialSelected !== 'all') {
                  return value?.branchChecklistId === materialSelected;
                }
                return true;
              })?.length > 0 && (
                <Stack
                  direction={maxSM ? 'column' : 'row'}
                  style={{
                    justifyContent: 'center',
                    alignItems: maxSM && 'center',
                    marginTop: 16
                  }}
                  spacing={2}
                  divider={
                    // eslint-disable-next-line react/jsx-wrap-multilines
                    <Divider
                      orientation={maxSM ? 'horizontal' : 'vertical'}
                      flexItem
                    />
                  }
                >
                  <Stack
                    spacing={2}
                    justifyContent="space-between"
                    alignItems={maxSM ? 'center' : 'flex-start'}
                    style={{ width: '100%' }}
                  >
                    <OrientationTitle
                      style={{
                        color: '#f00',
                        textAlign: maxSM ? 'center' : 'left',
                        textDecoration: 'none',
                        width: '122px'
                      }}
                    >
                      Tipo de Material:
                    </OrientationTitle>
                    <Box
                      style={{
                        height: '100%',
                        maxHeight: maxMD ? '140px' : maxSM ? '100px' : '200px'
                      }}
                    />
                    {checkList
                      ?.filter((value) => {
                        if (materialSelected && materialSelected !== 'all') {
                          return value?.branchChecklistId === materialSelected;
                        }

                        return value.agroupBy === 0;
                      })
                      ?.map((value) => (
                        <OrientationDescription
                          key={value.branchChecklistId}
                          style={{
                            color: '#f00',
                            textAlign: 'left',
                            fontWeight: 'bold',
                            height: maxSM ? '60px' : maxMD ? '120px' : '80px',
                            maxHeight: maxSM ? '60px' : maxMD ? '120px' : '80px'
                          }}
                        >
                          {value.materialName}
                          {checkList
                            ?.filter(
                              ({ agroupBy }) =>
                                agroupBy === value.branchChecklistId
                            )
                            ?.map(({ materialName }) => (
                              <>
                                <br />
                                {materialName}
                              </>
                            ))}
                        </OrientationDescription>
                      ))}
                    {/* <OrientationDescription
                    style={{
                      color: '#f00',
                      textAlign: 'left',
                      height: maxSM ? '60px' : maxMD ? '120px' : '80px',
                      maxHeight: maxSM ? '60px' : maxMD ? '120px' : '80px'
                    }}
                  >
                    Vestuário <br /> Têxtil <br /> Calçados
                  </OrientationDescription>
                  <OrientationDescription
                    style={{
                      color: '#f00',
                      textAlign: 'left',
                      height: maxSM ? '60px' : maxMD ? '120px' : '80px',
                      maxHeight: maxSM ? '60px' : maxMD ? '120px' : '80px'
                    }}
                  >
                    Vidros <br /> Porcelanas
                  </OrientationDescription>
                  <OrientationDescription
                    style={{
                      color: '#f00',
                      textAlign: 'left',
                      height: maxSM ? '60px' : maxMD ? '120px' : '80px',
                      maxHeight: maxSM ? '60px' : maxMD ? '120px' : '80px'
                    }}
                  >
                    Borracha <br /> Embalagens
                  </OrientationDescription> */}
                  </Stack>

                  <Stack
                    spacing={2}
                    justifyContent="space-between"
                    alignItems="center"
                    style={{ width: '100%' }}
                  >
                    <OrientationTitle>Embalagem:</OrientationTitle>
                    <img
                      src={transport.transport01}
                      alt="Embalagem"
                      style={{
                        height: '100%',
                        maxHeight: maxMD ? '140px' : maxSM ? '100px' : '200px'
                      }}
                    />
                    {checkList
                      ?.filter((value) => {
                        if (materialSelected && materialSelected !== 'all') {
                          return value?.branchChecklistId === materialSelected;
                        }
                        return value.agroupBy === 0;
                      })
                      ?.map((value) => (
                        <OrientationDescription
                          key={value.branchChecklistId}
                          style={{
                            height: maxSM ? '60px' : maxMD ? '120px' : '80px',
                            maxHeight: maxSM ? '60px' : maxMD ? '120px' : '80px'
                          }}
                        >
                          {value.packageDescription}
                        </OrientationDescription>
                      ))}
                    {/* <OrientationDescription
                    style={{
                      height: maxSM ? '60px' : maxMD ? '120px' : '80px',
                      maxHeight: maxSM ? '60px' : maxMD ? '120px' : '80px'
                    }}
                  >
                    Mercadorias devem estar devidamente embaladas em caixa de
                    papelão.
                  </OrientationDescription>
                  <OrientationDescription
                    style={{
                      height: maxSM ? '60px' : maxMD ? '120px' : '80px',
                      maxHeight: maxSM ? '60px' : maxMD ? '120px' : '80px'
                    }}
                  >
                    Embalagem somente com estrutura de madeira/pallet que permita
                    mobilidade de mercadoria.
                  </OrientationDescription>
                  <OrientationDescription
                    style={{
                      height: maxSM ? '60px' : maxMD ? '120px' : '80px',
                      maxHeight: maxSM ? '60px' : maxMD ? '120px' : '80px'
                    }}
                  >
                    Mercadorias devem estar devidamente embaladas em caixa de
                    papelão.
                  </OrientationDescription> */}
                  </Stack>

                  <Stack
                    spacing={2}
                    justifyContent="space-between"
                    alignItems="center"
                    style={{ width: '100%' }}
                  >
                    <OrientationTitle>Peso:</OrientationTitle>
                    <img
                      src={transport.transport02}
                      alt="Peso"
                      style={{
                        height: '100%',
                        maxHeight: maxMD ? '140px' : maxSM ? '100px' : '200px'
                      }}
                    />
                    {checkList
                      ?.filter((value) => {
                        if (materialSelected && materialSelected !== 'all') {
                          return value?.branchChecklistId === materialSelected;
                        }
                        return value.agroupBy === 0;
                      })
                      ?.map((value) => (
                        <OrientationDescription
                          key={value.branchChecklistId}
                          style={{
                            height: maxSM ? '60px' : maxMD ? '120px' : '80px',
                            maxHeight: maxSM ? '60px' : maxMD ? '120px' : '80px'
                          }}
                        >
                          {value.weightDescription}
                        </OrientationDescription>
                      ))}
                    {/* <OrientationDescription
                    style={{
                      height: maxSM ? '60px' : maxMD ? '120px' : '80px',
                      maxHeight: maxSM ? '60px' : maxMD ? '120px' : '80px'
                    }}
                  >
                    Não pode ultrapassar de 70kg por volume, caso ultrapasse será
                    analisado por uma equipe.
                  </OrientationDescription>
                  <OrientationDescription
                    style={{
                      height: maxSM ? '60px' : maxMD ? '120px' : '80px',
                      maxHeight: maxSM ? '60px' : maxMD ? '120px' : '80px'
                    }}
                  >
                    Não pode ultrapassar de 70kg por volume, caso ultrapasse será
                    analisado por uma equipe.
                  </OrientationDescription>
                  <OrientationDescription
                    style={{
                      height: maxSM ? '60px' : maxMD ? '120px' : '80px',
                      maxHeight: maxSM ? '60px' : maxMD ? '120px' : '80px'
                    }}
                  >
                    Não pode ultrapassar de 70kg por volume, caso ultrapasse será
                    analisado por uma equipe.
                  </OrientationDescription> */}
                  </Stack>

                  <Stack
                    spacing={2}
                    justifyContent="space-between"
                    alignItems="center"
                    style={{ width: '100%' }}
                  >
                    <OrientationTitle>Medidas:</OrientationTitle>
                    <img
                      src={transport.transport03}
                      alt="Medidas"
                      style={{
                        height: '100%',
                        maxHeight: maxMD ? '140px' : maxSM ? '100px' : '200px'
                      }}
                    />
                    {checkList
                      ?.filter((value) => {
                        if (materialSelected && materialSelected !== 'all') {
                          return value?.branchChecklistId === materialSelected;
                        }
                        return value.agroupBy === 0;
                      })
                      ?.map((value) => (
                        <OrientationDescription
                          key={value.branchChecklistId}
                          style={{
                            height: maxSM ? '60px' : maxMD ? '120px' : '80px',
                            maxHeight: maxSM ? '60px' : maxMD ? '120px' : '80px'
                          }}
                        >
                          {value.measureDescription}
                        </OrientationDescription>
                      ))}
                    {/* <OrientationDescription
                    style={{
                      height: maxSM ? '60px' : maxMD ? '120px' : '80px',
                      maxHeight: maxSM ? '60px' : maxMD ? '120px' : '80px'
                    }}
                  >
                    Não pode ultrapassar de 120 centímetros, caso ultrapasse será
                    analisado por uma equipe.
                  </OrientationDescription>
                  <OrientationDescription
                    style={{
                      height: maxSM ? '60px' : maxMD ? '120px' : '80px',
                      maxHeight: maxSM ? '60px' : maxMD ? '120px' : '80px'
                    }}
                  >
                    Não pode ultrapassar de 120 centímetros, caso ultrapasse será
                    analisado por uma equipe.
                  </OrientationDescription>
                  <OrientationDescription
                    style={{
                      height: maxSM ? '60px' : maxMD ? '120px' : '80px',
                      maxHeight: maxSM ? '60px' : maxMD ? '120px' : '80px'
                    }}
                  >
                    Não pode ultrapassar de 120 centímetros, caso ultrapasse será
                    analisado por uma equipe.
                  </OrientationDescription> */}
                  </Stack>
                </Stack>
                // eslint-disable-next-line indent
              )}
          </Paper>
          <Stack
            direction={maxSM ? 'column' : 'row'}
            spacing={2}
            justifyContent="space-between"
            style={{ paddingTop: 16 }}
          >
            <RadioWrapper>
              <Radio
                name="product-type"
                id="product-type-rejection"
                value="reject"
                data-testid="rejectRadioInput"
                onClick={handleReject}
              />
              <InputLabel htmlFor="product-type-rejection">Cancelar</InputLabel>
            </RadioWrapper>
            <RadioWrapper>
              <Radio
                name="product-type"
                id="product-type-confirmation"
                value="confirm"
                data-testid="acceptRadioInput"
                checked={false}
                disabled={isLoadingModal || isLoadingMaterial}
                onClick={handleAccept}
              />
              <InputLabel
                htmlFor="product-type-confirmation"
                disabled={isLoadingModal || isLoadingMaterial}
              >
                Concordo e aceito o termo de responsabilidade
              </InputLabel>
            </RadioWrapper>
          </Stack>
        </Box>
      </Content>
    </Container>
  );
};

export default GeneralShippingGuidelines;
